import firebase from 'firebase';
let messaging;

export const askForPermissioToReceiveNotifications = async () => {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
        return null;
    }
    if (!messaging || typeof messaging.getToken !== 'function') {
        return null;
    }
    try {
        const token = await messaging.getToken();
        return token;
    } catch (error) {
        return null;
    }
};

export const initializeFirebase = async () => {
    var config = {
        messagingSenderId: '122960842139',
    };
    firebase.initializeApp(config);
    messaging = firebase.messaging();
    if ('serviceWorker' in navigator) {
        if (navigator.serviceWorker.controller) {
            console.log('[PWA Builder] active service worker found, no need to register');
        } else {
            const registration = await navigator.serviceWorker.register(
                '/firebase-messaging-sw.js',
                { scope: './' }
            );
            messaging.useServiceWorker(registration);
            await messaging.requestPermission();
        }
    }
};
